module.exports = __webpack_public_path__ + "public/img/Menggunakan Bahasa Inggris Bagi Calon Tenaga Perkantoran Umum.a1ecfb40.png";